'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import PortalIdParser from 'PortalIdParser';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { Networks } from 'AdsUI/lib/Constants';
import StopPropagationWrapper from 'AdsUI/components/StopPropagationWrapper';

const CurrentUserNotConnected = ({
  network,
  action
}) => {
  const trackAction = useCallback(() => {
    usageTracker.track('multiAuthAction', {
      action: 'Clicked connect user link',
      network,
      context: action
    });
  }, [network, action]);
  return /*#__PURE__*/_jsxs(StopPropagationWrapper, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: `multiAuthPermissions.actions.${action}`,
      options: {
        network: I18n.text(network.toLowerCase())
      }
    }), ' ', /*#__PURE__*/_jsx(UILink, {
      external: true,
      href: `/settings/${PortalIdParser.get()}/marketing/ads/adAccounts`,
      onClick: trackAction,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "multiAuthPermissions.link",
        options: {
          network: I18n.text(network.toLowerCase())
        }
      })
    })]
  });
};

CurrentUserNotConnected.propTypes = {
  network: PropTypes.oneOf(Object.values(Networks)).isRequired,
  action: PropTypes.oneOf(['createAudiences', 'manageEntities', 'createAds', 'createEvents', 'installPixels', 'deleteAudiences', 'editEvents', 'acceptToS', 'applyDismissRecommendation']).isRequired
};
export default CurrentUserNotConnected;